export const formatCodeAndPhase = (code?: string, phase?: string) => {
  if (!phase && !code) return undefined;

  const parts = [];
  if (code) parts.push(`code: ${code}`);
  if (phase) parts.push(`phase: ${phase}`);

  return `(${parts.join(', ')})`;
};
